import { CheckIcon } from '@heroicons/react/20/solid';

import { Text } from '@northladder/i18n';

import { translations } from '../../translations';

/**
 * -----------------------------------------------------------------------------
 * UI shown when the user presses the done button and the API resets the session
 * navigating them to a clean slate.
 */
export function DoneUploading() {
  return (
    <div className="flex min-h-[calc(100vh-15rem)] flex-col justify-center">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          className="
            shadow-xs bg-white px-4 py-8 dark:bg-gray-900/50 sm:rounded-3xl
            sm:px-10
          "
        >
          <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
            <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
              <CheckIcon
                aria-hidden="true"
                className="
                  mx-auto my-12 h-16 w-16 rounded-full bg-green-100  p-4
                  text-green-900 dark:bg-green-500/10 dark:text-green-200
                "
              />
              <h1
                className="
                  text-primary-700 dark:text-primary-200 mt-4 text-xl font-normal
                  tracking-tight sm:text-xl
                "
              >
                <Text text={translations.doneUploading.title} />
              </h1>
              <p className="text-primary-900 my-8 max-w-xl font-light dark:text-gray-200">
                <Text text={translations.doneUploading.subTitle} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
